//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as Sentry from '@sentry/browser';
import gsoLogout from 'gso-logout';
import {read} from 'gso-session';
import {catchError} from 'gso-onerror';
import {getMenu} from 'gso-apps-menu';
import PowerSettingsNewIcon from 'gso-design-icons/vue/material-design/power_settings_new.vue';
import {isDefined} from 'gso-utilities';
import is from '@sindresorhus/is';
import isLoggedIn from '../is-logged-in';
import resolve from '../resolve-url';
import GroupsLogo from './groups-logo.vue';
import Account from './account.vue';
import Inbox from './inbox.vue';
import Apps from './portal-apps.vue';
import Help from './help.vue';
import ParamUniverse from './param-universe.vue';

function getTitle() {
	let title = document.title;
	if (title !== 'Group S Online') {
		title = title
			.replace(/\s+/gi, ' ') // Normalize whitespace
			.replace(/( ?)([^ a-zA-Zéèêîôû'´`]+)( ?)/gi, ' ') // Remove special chars
			.replace(/(\b)(gro(u|e)p(e)?(s)?)(\b)/gi, 'group') // Normalize "Group"
			.replace(/( *)(\b)(group)(\b)(( )(s))?(( )(online))?/gi, '') // Remove "Group S"/"Group S Online"
			.trim(); // Trim whitespace
		if (title === '') {
			console.warn(
				'Could not guess the App title from the <title> tag. Does it include the app name ?'
			);
			title = 'Group S Online'; // default value
		}
	}

	return title;
}

function universe() {
	const res = read('universe');
	return res && res.name;
}

function hasInboxAccess(user) {
	if (!isDefined(user) || !is.array(user.accessRights)) {
		return false;
	}

	const inboxAccessRights = user.accessRights.find(
		element => element.application === 'inbox'
	);

	return (
		inboxAccessRights.access === 'readwrite' ||
		inboxAccessRights.access === 'read'
	);
}

/**
 * Test if the Documents application is the only one in the list.
 */
function hasOnlyDocuments(groups) {
	const apps = groups.reduce((apps, group) => apps.concat(group.apps), []);
	return apps.length === 1 && apps[0].id === 'idocument';
}

/**
 * Test if the user is a simple worker inside the application Documents.
 */
function isSimpleWorkerInDocuments() {
	const user = read('user');
	const rights = user.accessRights.find(
		rights => rights.application === 'idocument'
	);
	return !rights.items.some(
		item => item.id === 'administration' && item.access !== 'denied'
	);
}

export default {
	name: 'gso-header',
	components: {
		GroupsLogo,
		Account,
		Inbox,
		Apps,
		PowerSettingsNewIcon,
		Help,
		ParamUniverse
	},
	props: {
		helpHref: {
			type: String,
			required: false
		},
		userGuide: {
			type: [String, Array],
			required: false
		},
		titleHeader: {
			type: String,
			required: false
		}
	},
	data() {
		let loggedIn = false;
		let hiddenInbox = true;
		if (isLoggedIn()) {
			const user = read('user');
			loggedIn = true;
			hiddenInbox = !hasInboxAccess(user);
		}

		return {
			title: this.titleHeader || getTitle(),
			universe: universe(),
			loggedIn,
			hiddenInbox,
			groups: []
		};
	},
	computed: {
		hiddenDenomination() {
			return hasOnlyDocuments(this.groups) && isSimpleWorkerInDocuments();
		}
	},
	async mounted() {
		if (!this.loggedIn) {
			return;
		}

		try {
			this.groups = await getMenu();
		} catch (error) {
			Sentry.captureException(error);
			catchError(error);
		}
	},
	methods: {
		logout() {
			return gsoLogout(url => resolve(url, this.$store.state.header.baseUrl));
		}
	}
};
